export default __webpack_public_path__ + "static/media/Productinfo 1024.fcec2e58.svg";